var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.78 3H4.22C3.82175 3 3.5 3.32175 3.5 3.72V20.28C3.5 20.6783 3.82175 21 4.22 21H20.78C21.1783 21 21.5 20.6783 21.5 20.28V3.72C21.5 3.32175 21.1783 3 20.78 3ZM18.701 8.25375H17.2633C16.136 8.25375 15.9178 8.78925 15.9178 9.57675V11.3115H18.6088L18.2578 14.0273H15.9178V21H13.112V14.0295H10.7653V11.3115H13.112V9.309C13.112 6.98475 14.5318 5.718 16.6063 5.718C17.6008 5.718 18.4535 5.79225 18.7033 5.826V8.25375H18.701Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFill);
export default __webpack_public_path__ + "static/media/facebook-fill.9b79ca0db7ceb61fbc57c0ece19c3729.svg";
export { ForwardRef as ReactComponent };